// extracted by mini-css-extract-plugin
module.exports = {"main":"MainPage_main__etlkD","main-section":"MainPage_main-section__1MA7B","main-aside":"MainPage_main-aside__3vFpW"};